import type { MenuItem } from "~/models/MenuItem"

export const profile_menu: MenuItem[] = [
    // {
    //     title: 'shoppingCard.my',
    //     icon: 'credit_card',
    //     route: 'shoppingCard.my',
    //     color: 'grey-9',
    //     can: props => props.auth.user != null
    // },
    {
        title: "orders.my",
        route: "/profile/orders",
        icon: "request_quote",
        color: "grey-9",
        can: (user: User) => user != null,
        dataCy: "profile-menu-orders",
    },
    {
        title: "fields.beneficiary",
        route: "/profile/beneficiaries",
        icon: "users",
        color: "grey-9",
        can: (user: User) => user != null,
        dataCy: "profile-menu-beneficiaries",
    },
    // {
    //     title: "points_system.my",
    //     route: "/profile/points",
    //     icon: "request_quote",
    //     color: "grey-9",
    //     can: (user:User) => user != null,
    // },
    {
        title: "promotion.title",
        route: "/profile/promotions",
        icon: "request_quote",
        color: "grey-9",
        can: (user: User) =>
            user != null &&
            user.is_promotor &&
            user.promotor != null &&
            user.promotor.status == "approved",
        dataCy: "profile-menu-promotions",
    },
    {
        title: "promotion.analytic",
        route: "/profile/promotions/analitics",
        icon: "request_quote",
        color: "grey-9",
        can: (user: User) =>
            user != null &&
            user.is_promotor &&
            user.promotor != null &&
            user.promotor.status == "approved",
        dataCy: "profile-menu-promotions-analytics",
    },
]

export const navbar_menu: {
    route_name: string
    route_current: string
    show_condition: Function | null
    name: string
}[] = [
    {
        route_name: "store",
        route_current: "store",
        show_condition: null,
        name: "home.store",
    },
    {
        route_name: "shopping-card-info",
        route_current: "shopping-card-info",
        show_condition: (page: { props: { enable_shopping_card_info: any } }) =>
            page.props.enable_shopping_card_info,
        name: "home.shopping_card_info",
    },
    {
        route_name: "store.services",
        route_current: "store.services",
        show_condition: () => false,
        name: "home.services",
    },
    {
        route_name: "blogs.index",
        route_current: "blogs.index",
        show_condition: null,
        name: "blog.title",
    },
    {
        route_name: "contact",
        route_current: "contact",
        show_condition: null,
        name: "home.contact_us",
    },
    {
        route_name: "about",
        route_current: "about",
        show_condition: (page: {
            props: { information: { enable_about_us: any } }
        }) => page.props.information.enable_about_us,
        name: "home.about_us",
    },
    {
        route_name: "frequent-asks",
        route_current: "frequent-asks",
        show_condition: (page: {
            props: { information: { enable_frequent_asks: any } }
        }) => page.props.information.enable_frequent_asks,
        name: "fields.faq",
    },
]

/**
 * Main menu
 *
 * @author Abel David.
 */
export const main_menu: MenuItem[] = [
    {
        title: "nav.manage",
        icon: "sym_o_work",
        color: "grey-9",
        breadCrumbRoute: true,
        children: [
            // {
            //     title: 'nav.dashboard',
            //     icon: 'dashboard',
            //     color: 'grey-9',
            //     children: [
            //         {
            //             title: 'analytics.title',
            //             route: 'analytics',
            //             icon: 'area_chart',
            //             color: 'grey-9',
            //             can: 'read_analytics'
            //         }
            //     ]
            // },
            {
                title: "users.title",
                route: "/admin/users",
                icon: "sym_o_group",
                color: "grey-9",
                //can: 'read_users'
            },
            {
                title: "roles.title",
                route: "/admin/roles",
                icon: "sym_o_verified_user",
                color: "grey-9",
                can: "read_roles",
            },
            {
                title: "point_of_sales.title",
                route: "/admin/point_of_sales",
                icon: "sym_o_point_of_sale",
                color: "grey-9",
                can: "read_pos",
            },
            {
                title: "products.title",
                icon: "sym_o_local_mall",
                color: "grey-9",
                children: [
                    {
                        title: "products.list",
                        route: "/admin/products",
                        icon: "sym_o_apparel",
                        color: "grey-9",
                        can: "read_products",
                    },
                    {
                        title: "products.combos",
                        route: "/admin/combos",
                        icon: "sym_o_fastfood",
                        color: "grey-9",
                        can: "read_products",
                    },
                    {
                        title: "categories.title",
                        route: "/admin/categories",
                        icon: "sym_o_category",
                        color: "grey-9",
                        can: "read_categories",
                    },
                    {
                        title: "attributes.title",
                        route: "/admin/attributes",
                        icon: "extension",
                        color: "grey-9",
                        can: "read_attributes",
                    },
                    {
                        title: "brands.title",
                        route: "/admin/brands",
                        icon: "sym_o_shoppingmode",
                        color: "grey-9",
                        // can: "read_brands",
                    },
                ],
            },
            {
                title: "sale.title",
                icon: "sym_o_paid",
                color: "grey-9",
                children: [
                    {
                        title: "invoices.title",
                        route: "/admin/invoices",
                        icon: "sym_o_receipt_long",
                        color: "grey-9",
                        can: "read_invoices",
                    },
                    {
                        title: "orders.title",
                        route: "/admin/orders",
                        icon: "sym_o_local_shipping",
                        color: "grey-9",
                        can: "read_orders",
                    },
                    {
                        title: "report.product_gift_cards",
                        color: "grey-9",
                        icon: "print",
                        route: "/admin/printGiftCards",
                        can: "print_giftProduct",
                    },
                    // {
                    //     title: 'reservations.title',
                    //     route: 'reservations.index',
                    //     icon: 'book_online',
                    //     color: 'grey-9',
                    //     can: 'read_reservation'
                    // },
                ],
            },
            {
                title: "gift_cards.title",
                route: "/admin/gift_cards",
                icon: "sym_o_featured_seasonal_and_gifts",
                color: "grey-9",
                can: "read_giftProduct",
            },
            {
                title: "offers.title",
                route: "/admin/offers",
                icon: "sym_o_redeem",
                color: "grey-9",
                can: "read_offers",
            },
            {
                title: "testimonials.title",
                route: "/admin/testimonials",
                icon: "sym_o_3p",
                color: "grey-9",
            },
            {
                title: "banners.title",
                route: "/admin/banners",
                icon: "sym_o_panorama",
                color: "grey-9",
                can: "read_banners",
            },

            // {
            //     title: 'shoppingCard.sale_in_store',
            //     icon: 'storefront',
            //     route: 'sales_buy_card',
            //     color: 'grey-9',
            //     can: 'sale_buy_car_invoices'
            // },
            // {
            //     title: "orderStatuses.title",
            //     route: "/admin/orderStatuses",
            //     icon: "update",
            //     color: "grey-9",
            //     can: "read_orderStatuses",
            // },
            {
                title: "report.title",
                icon: "sym_o_assignment",
                color: "grey-9",
                can: "read_reports",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "report.for_sale",
                        route: "/admin/reports/sale",
                        icon: "sym_o_request_page",
                        can: "read_for_sale_reports",
                        color: "grey-9",
                    },
                    {
                        title: "report.unify",
                        route: "/admin/reports/unify_sale",
                        icon: "sym_o_price_check",
                        color: "grey-9",
                    },
                    {
                        title: "report.for_inventary",
                        route: "/admin/reports/inventory",
                        icon: "sym_o_inventory",
                        color: "grey-9",
                        can: "read_for_inventary_reports",
                    },
                    {
                        title: "report.orders",
                        color: "grey-9",
                        icon: "sym_o_receipt",
                        route: "/admin/reports/orders",
                        can: "read_for_order_reports",
                    },
                    {
                        title: "report.movements",
                        color: "grey-9",
                        icon: "sym_o_warehouse",
                        route: "/admin/reports/movements",
                        can: "read_for_movement_reports",
                    },
                    // {
                    //     title: 'shoppingCard.title',
                    //     color: 'grey-9',
                    //     icon: 'credit_card',
                    //     route: '/admin/reports/shoppingCard',
                    //     can: 'report_shopping_cards'
                    // },
                    {
                        title: "report.salesaccounting",
                        color: "grey-9",
                        icon: "sym_o_credit_card",
                        route: "/admin/reports/salesaccounting",
                        can: "read_for_sales_accounting_reports",
                    },
                    {
                        title: "report.sold_product",
                        color: "grey-9",
                        icon: "sym_o_add_shopping_cart",
                        route: "/admin/reports/soldProduct",
                        can: "read_for_sold_products",
                    },
                    {
                        title: "report.catalog",
                        color: "grey-9",
                        icon: "sym_o_package_2",
                        route: "/admin/reports/catalog",
                    },
                ],
            },
            {
                title: "blog.title",
                color: "grey-9",
                icon: "sym_o_book_ribbon",
                breadCrumbRoute: true,
                children: [
                    {
                        route: "/admin/blogs/posts",
                        title: "post.title",
                        icon: "sym_o_post",
                        color: "grey-9",
                        can: "read_post",
                    },
                    {
                        route: "/admin/blogs/categories",
                        title: "blog_categories.title",
                        icon: "sym_o_interests",
                        color: "grey-9",
                    },
                    {
                        route: "/admin/blogs/keywords",
                        title: "keywords.title",
                        icon: "sym_o_tag",
                        color: "grey-9",
                    },
                ],
            },
            {
                title: "review_menu.title",
                color: "grey-9",
                icon: "sym_o_rate_review",
                children: [
                    {
                        title: "valoration.title",
                        color: "gray-9",
                        icon: "sym_o_comment_bank",
                        route: "/admin/criterias",
                        can: "criteria_and_answer",
                    },
                    {
                        title: "products.validation_review",
                        color: "gray-9",
                        icon: "sym_o_reviews",
                        route: "/admin/reviews",
                        can: "rating_products",
                    },
                ],
            },
            {
                title: "promotor.title",
                color: "gray-9",
                icon: "sym_o_campaign",
                breadCrumbRoute: true,
                children: [
                    {
                        title: "nomenclator.title",
                        color: "gray-9",
                        icon: "sym_o_abc",
                        route: "/admin/nomenclator",
                        can: [
                            "read_nomenclator",
                            "update_nomenclator",
                            "create_nomenclator",
                            "delete_nomenclator",
                        ],
                    },
                    {
                        title: "promotor.menu_verify_promotors",
                        color: "gray-9",
                        icon: "sym_o_verified",
                        route: "/admin/promotors/verify",
                        can: ["read_promotor", "update_promotor"],
                    },
                    {
                        title: "promotion.promotions_commision",
                        color: "gray-9",
                        icon: "sym_o_payments",
                        route: "/admin/promotions/promotors",
                        can: ["read_nomenclator"],
                    },
                    {
                        title: "promotor.drawer_request",
                        color: "gray-9",
                        icon: "sym_o_verified",
                        route: "/admin/promotors/drawer_request",
                        can: ["read_promotor", "update_promotor"],
                    },
                ],
            },
            // {
            //     title: "points_system.title",
            //     route: "/admin/pointsSystem",
            //     icon: "sym_o_rewarded_ads",
            //     color: "grey-9"
            // },
        ],
    },
    {
        title: "settings.title",
        icon: "sym_o_settings_account_box",
        color: "grey-9",
        breadCrumbRoute: true,
        children: [
            {
                title: "settings.generals",
                route: "/admin/settings/generals",
                icon: "sym_o_handyman",
                color: "grey-9",
                can: ["update_general_settings"],
            },
            {
                title: "settings.customization",
                route: "/admin/settings/customization",
                icon: "sym_o_palette",
                color: "grey-9",
                can: ["update_customization_settings"],
            },
            {
                title: "Monedas",
                route: "/admin/settings/coins",
                icon: "sym_o_payments",
                color: "grey-9",
                can: "read_coins",
            },
            {
                title: "Tasa de cambio",
                route: "/admin/settings/exchangeRates",
                icon: "sym_o_currency_exchange",
                color: "grey-9",
                can: "read_exchange_rate",
            },
        ],
    },
    {
        title: "nav.analytics",
        icon: "sym_o_line_axis",
        color: "grey-9",
        breadCrumbRoute: true,
        children: [
            {
                title: "analytics.visits",
                route: "/admin/analytics/visits",
                icon: "sym_o_query_stats",
                color: "grey-9",
                can: "read_analytics",
            },
            {
                title: "analytics.sales",
                route: "/admin/analytics/sales",
                icon: "sym_o_monitoring",
                color: "grey-9",
                can: "read_analytics",
            },
            {
                title: "analytics.products",
                route: "/admin/analytics/mostsold",
                icon: "sym_o_insert_chart",
                color: "grey-9",
                can: "read_analytics",
            },
            {
                title: "analytics.promotions",
                route: "/admin/analytics/promotors",
                icon: "sym_o_ssid_chart",
                color: "grey-9",
                can: "read_analytics",
            },
        ],
    },
]
